import { isNil } from 'lodash';
import { useContext } from 'react';
import { AskContext } from './AskContext';
import { AskContextValue } from './types';

export function useAsk(): AskContextValue {
  const context = useContext(AskContext);
  if (isNil(context)) {
    throw new Error('useAsk must be used within an AskProvider');
  }
  return context;
}
